export default "__VITE_ASSET__05a95ade__"